import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireUrlParse } from "../node_modules/.pnpm/url-parse@1.5.10/node_modules/url-parse/index.js";
var urlParseExports = requireUrlParse();
const URL = /* @__PURE__ */ getDefaultExportFromCjs(urlParseExports);
export {
  URL as default
};
//# sourceMappingURL=index2.js.map
